import _sfc_main from "./BuyBoxNotifyMe2.mjs";
/* empty css                 */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxNotifyMe = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-5ba81558"]]);
export {
  BuyBoxNotifyMe as default
};
//# sourceMappingURL=BuyBoxNotifyMe.mjs.map
